export * from './login.component'

import {NotificationComponent} from './notification/notification.component';

export const LOGIN_COMPONENTS = [
    NotificationComponent
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/login/index.ts